<template>
    <v-dialog v-model="exibeModal" width="800" persistent>
        <v-card>
            <v-card-title
                class="body-2 font-weight-bold primary white--text"
                primary-title>
                Nova Reavaliação
                <v-spacer/>
                <v-btn icon small dark @click="fecharModalReavaliacao">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-form class="az-form-content form py-4 px-4" lazy-validation ref="form">
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="patrimonio.numero"
                            label="Nº Patrimônio"
                            v-validate="'required|max:50'"
                            maxlength="50"
                            name="patrimonioNumero"
                            placeholder="Informe o número"
                            disabled
                            :error-messages="errors.collect('patrimonioNumero')"/>
                    </v-col>

                    <v-col>
                        <v-text-field
                            v-model="patrimonio.descricao"
                            label="Descrição"
                            v-validate="'required|max:50'"
                            maxlength="50"
                            name="patrimonioNumero"
                            placeholder="Informe o número"
                            disabled
                            :error-messages="errors.collect('patrimonioNumero')"/>
                    </v-col>

                    <v-col>
                        <az-money
                            v-model="patrimonio.valorAquisicao"
                            required
                            disabled
                            label="Valor Entrada"
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'"
                            @input="atualizarValorInserido($event)">
                        </az-money>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <az-money
                            v-model="patrimonio.valorLiquido"
                            required
                            disabled
                            label="Valor Líquido"
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'"
                            @input="atualizarValorInserido($event)">
                        </az-money>
                    </v-col>

                    <v-col>
                        <v-text-field
                            :value="retornaTextoPeriodoVidaUtil"
                            append-icon="fas fa-calendar"
                            label="Período Licença"
                            v-validate="'required|max:50'"
                            maxlength="50"
                            name="patrimonioNumero"
                            placeholder="Informe o número"
                            disabled
                            :error-messages="errors.collect('patrimonioNumero')"/>
                    </v-col>

                    <v-col>
                        <v-text-field
                            :value="meses"
                            label="Período Licença em Meses"
                            v-validate="'required|max:50'"
                            maxlength="50"
                            name="patrimonioNumero"
                            placeholder="Informe o número"
                            disabled
                            :error-messages="errors.collect('patrimonioNumero')"/>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="4">
                        <v-text-field
                            v-model="reavaliacao.metodo"
                            v-validate="'required|max:50'"
                            maxlength="50"
                            name="reavaliacaoMetodo"
                            placeholder="Informe o método"
                            :error-messages="errors.collect('reavaliacaoMetodo')">
                            <template v-slot:label>
                                Método
                                <span class="ml-1 red--text">*</span>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="4">
                        <az-money
                            v-model="reavaliacao.valorAvaliacao"
                            :event-submit="'blur'"
                            required
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'"
                            :maxLength="18"
                            @input="atualizarValorInserido($event)">
                            <template v-slot:label>
                                Valor Avaliação
                                <span class="ml-1 red--text">*</span>
                            </template>
                        </az-money>
                    </v-col>

                    <v-col cols="4">
                        <v-text-field
                            ref="valorReavaliado"
                            v-model="reavaliacao.valorReavaliadoFormatado"
                            required
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'"
                            :maxLength="18"
                            label="Valor Reavaliado"
                            disabled>
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="4">
                        <v-text-field
                            v-model="reavaliacao.comissao"
                            maxlength="100"
                            name="comissaoResponsavel"
                            placeholder="Informe a comissão"
                            :error-messages="errors.collect('comissaoResponsavel')">
                            <template v-slot:label>
                                <span>
                                    Comissão Responsável
                                    <span class="red--text">*</span>
                                </span>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="reavaliacao.observacoes"
                            counter="500"
                            auto-grow
                            class="mt-2"
                            rows="2"
                            label="Observações"
                            v-validate="'max:500'"
                            data-vv-as="observacoes"
                            name="observacoes"
                            :maxlength="500"
                            type="text"
                            placeholder="Informe a observação."
                            :error-messages="errors.collect('observacoes')">
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-form>

            <v-divider></v-divider>
            <v-card-actions>
                <v-flex class="row pa-3 ma-0">
                    <v-btn color="grey" text outlined width="150" class="text-body-2"
                           @click="fecharModalReavaliacao">
                        Cancelar
                    </v-btn>
                    <v-spacer/>
                    <v-spacer/>
                    <v-btn
                        v-if="validarCampos"
                        depressed
                        width="150"
                        class="text-body-2" color="primary" :disabled="!verificaPermissaoEdicao || !podeSalvar"
                        @click="salvarReavaliacao"
                    >
                        Salvar
                    </v-btn>
                    <v-tooltip
                        v-else
                        nudge-top="0"
                        top
                        transition="scale-transition"
                        origin="center center"
                        max-width="300"
                    >
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn v-on="on" disabled depressed width="150" class="text-body-2"
                                       color="primary">
                                    Salvar
                                </v-btn>
                            </div>
                        </template>
                        Preencha todos os campos obrigatórios para salvar a reavaliação.
                    </v-tooltip>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'
    import {actionTypes} from '@/core/constants'

    export default {
        name: 'ModalReavaliacao',
        $_veeValidate: {
            validator: 'new',
        },
        data() {
            return {
                exibeModal: true,
                reavaliacao: {},
                podeSalvar: true
            }
        },
        computed: {
            ...mapState({patrimonio: state => state.patrimonio.patrimonio}),
            validarCampos() {
                return this.reavaliacao.metodo && this.reavaliacao.valorAvaliacao && this.reavaliacao.comissao
            },
            verificaPermissaoEdicao() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
            },
            retornaTextoPeriodoVidaUtil() {
                const dataInicio = this.patrimonio.inicioVidaUtil
                const dataFim = this.patrimonio.fimVidaUtil
                return `${this.$options.filters.azDate(dataInicio)} a ${this.$options.filters.azDate(dataFim)}`
            },
            meses() {
                if (this.patrimonio && this.patrimonio.periodoVidaUtil) {
                    return this.patrimonio.periodoVidaUtil.mes
                }
                return 0
            }
        },
        methods: {
            ...mapActions([
                actionTypes.REAVALIACAO.CADASTRAR_REAVALIACAO
            ]),
            fecharModalReavaliacao() {
                this.podeSalvar = false
                this.$emit('fecharModalReavaliacao')
            },
            atualizarValorInserido(value) {
                this.reavaliacao.valorAvaliacao = value
                this.atualizarValorReavaliado()
            },
            atualizarValorReavaliado() {
                const valorAmortizado = this.patrimonio.configAmortizacao ? this.patrimonio.configAmortizacao.valorAmortizadoAcumulado: 0
                const valorReavaliado = this.reavaliacao.valorAvaliacao - valorAmortizado
                this.reavaliacao.valorReavaliado = valorReavaliado
                this.reavaliacao.valorReavaliadoFormatado = valorReavaliado.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
            },
            async salvarReavaliacao() {
                await this.cadastrarReavaliacao({
                    patrimonioId: this.$route.params.id,
                    metodo: this.reavaliacao.metodo,
                    valorAvaliacao: this.reavaliacao.valorAvaliacao,
                    valorReavaliado: this.reavaliacao.valorReavaliado,
                    comissao: this.reavaliacao.comissao,
                    observacoes: this.reavaliacao.observacoes
                })
                this.fecharModalReavaliacao()
            }
        }
    }
</script>
